import { apiClient } from "@/core/api/ApiClient";
import { CustomerDto, EntityType } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: CustomerDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function CustomerDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.Customer}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.customersApi.apiV1CustomersCustomerIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          customerId: params.entityId,
          isDeleteCascade: params.isDeleteCascade,
        });
      }}
      {...otherProps}
    />
  );
}
